<template>
  <section>
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <div class="row">
            <div class="col-6">
              <z-select v-model="vehicleMake" label="Make" :options="vehicles" validate="required" @change="isSave = true" />
            </div>
            <div class="col-6">
              <z-input v-model="vehicleModel" label="Model" @keyup="isSave = true" />
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <z-select v-model="yearStart" label="Year Start" :options="years" @change="isSave = true" />
            </div>
            <div class="col-3">
              <z-select v-model="yearEnd" label="Year End" :options="years" @change="isSave = true" />
            </div>
            <div class="col custom-inactive">
              <input v-model="isInactive" class="custom-checkbox ml-2" type="checkbox" @change="isSave = true" />
              <span class="ml-2">Inactive?</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <z-input v-model="reason" label="Reason" @keyup="isSave = true" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-1">
            {{ id }}
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col-3 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button type="button" class="btn btn-primary ms-2" :class="{ 'btn-danger': isSave }" @click="save()">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
export default {
  name: 'DialogNoScrub',
  components: {
    ZDialog,
    ZMessage,
    ZInput,
    ZSelect
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modalSize: 'modal-md',
      isSave: false,
      message: null
    }
  },
  emits: ['input', 'closing', 'saved'],
  computed: {
    ...mapState(adasmatrixStore, ['noScrubItem', 'lookups']),
    title() {
      let _title = 'Add No Scrub'
      if (this.modelValue !== null) {
        if (this.modelValue.type === 'EDIT') {
          _title = 'Edit No Scrub'
        }
      }
      return _title
    },
    isVisible: {
      get() {
        return this.modelValue !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    id() {
      let _id = null
      if (this.noScrubItem) {
        _id = this.noScrubItem.adasNoScrubList
      }
      return _id
    },
    vehicles() {
      return this.lookups['VehicleMake']
    },
    years() {
      let _years = [
        {
          name: '',
          value: null
        }
      ]
      let _now = new Date()
      let _year = _now.getFullYear()
      for (var i = _year + 2; i >= _year - 20; i--) {
        _years.push({
          name: i,
          value: i
        })
      }
      console.log('Years', _years)
      return _years
    },
    vehicleMake: {
      get() {
        let _data = null
        if (this.noScrubItem) {
          _data = this.noScrubItem.vehicleMake
        }
        return _data
      },
      set(value) {
        this.updateNoScrubItem({
          name: 'vehicleMake',
          value: parseInt(value)
        })
      }
    },
    vehicleModel: {
      get() {
        let _data = null
        if (this.noScrubItem) {
          _data = this.noScrubItem.vehicleModel
        }
        return _data
      },
      set(value) {
        this.updateNoScrubItem({
          name: 'vehicleModel',
          value: value
        })
      }
    },
    yearStart: {
      get() {
        let _data = null
        if (this.noScrubItem) {
          _data = this.noScrubItem.yearStart
        }
        return _data
      },
      set(value) {
        this.updateNoScrubItem({
          name: 'yearStart',
          value: parseInt(value)
        })
      }
    },
    yearEnd: {
      get() {
        let _data = null
        if (this.noScrubItem) {
          _data = this.noScrubItem.yearEnd
        }
        return _data
      },
      set(value) {
        this.updateNoScrubItem({
          name: 'yearEnd',
          value: parseInt(value)
        })
      }
    },
    reason: {
      get() {
        let _data = null
        if (this.noScrubItem) {
          _data = this.noScrubItem.reason
        }
        return _data
      },
      set(value) {
        this.updateNoScrubItem({
          name: 'reason',
          value: value
        })
      }
    },
    isInactive: {
      get() {
        let _data = ''
        if (this.noScrubItem) {
          _data = this.noScrubItem.isInactive
        }
        return _data
      },
      set(value) {
        this.updateNoScrubItem({
          name: 'isInactive',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['updateNoScrubItem', 'saveNoScrubItem']),
    close() {
      this.$emit('closing')
    },
    async save() {
      if (this.isSave) {
        let valid = true
        if (this.noScrubItem.vehicleMake === null) {
          valid = false
        }
        if (valid) {
          await this.saveNoScrubItem(this.noScrubItem)
          this.isSave = false
          this.$emit('saved')
        } else {
          this.message = 'Please fill in all required fields.'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
  min-height: 250px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-textarea {
  height: 200px;
}
.custom-right-align {
  text-align: right;
}
.custom-value-wrapper {
  position: relative;
  top: 35px;
}
.custom-inactive {
  padding-top: 40px;
}
</style>
